module.exports = __webpack_public_path__ + "img/1.29e878f9.jpeg";